const doc = [({"en":({"js":({"models_table":({"add_column_button":({"label":"Label", "please_choose_an_attribute":"Please choose an attribute"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;